import Alert from "@/models/AlertClass";

const state = {
  alerts: []
};
const getters = {
  exist: state => {
    if (state.alerts.length > 0) return true;
    return false;
  },
  list: state => {
    return state.alerts;
  }
};
const actions = {
  push: ({ commit }, payload) => {
    commit("pushAlert", payload);
  },
  remove: ({ commit }, payload) => {
    commit("removeAlert", payload);
  },
  pop: ({ commit }) => {
    commit("popAlert");
  },
  clear: ({ commit }) => {
    commit("clearAlert");
  }
};
const mutations = {
  pushAlert: (state, alert) => {
    state.alerts.push(new Alert(alert));
  },
  removeAlert: (state, id) => {
    state.alerts = state.alerts.filter(o => {
      return o.id != id;
    });
  },
  popAlert: state => {
    var item = state.alerts.filter(o => {
      return o.type != "error";
    })[0];
    if (item)
      state.alerts = state.alerts.filter(o => {
        return o.id != item.id;
      });
  },
  clearAlert: state => {
    state.alerts = [];
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
